"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreadcrumbSchema = void 0;
/**
 * Converts a breadcrumb object into a BreadcrumbList schema.
 * @param inputObject - The breadcrumb object to convert.
 * @returns The BreadcrumbList schema JSON string or undefined if the input object is invalid.
 */
function getBreadcrumbSchema(inputObject) {
    if (isValidBreadcrumbList(inputObject) === false) {
        return undefined;
    }
    const convertedBreadcrumbs = inputObject;
    return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: convertedBreadcrumbs
            .filter((item) => item && (item.name || item.label) && item.url)
            .map((item, index) => {
            const itemSchema = {
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@id': item.url,
                    name: item.label || item.name,
                    '@type': 'Thing',
                },
            };
            return itemSchema;
        }),
    });
}
exports.getBreadcrumbSchema = getBreadcrumbSchema;
/**
 * Type Guard: Checks if an unknown input is a valid Breadcrumb array.
 */
function isValidBreadcrumbList(inputObject) {
    return (Array.isArray(inputObject) &&
        inputObject.length > 0 &&
        inputObject.some((item) => item && typeof item === 'object' && ('label' in item || 'name' in item) && 'url' in item));
}
//# sourceMappingURL=breadcrumb-schema.js.map